import { useMapEvents } from 'react-leaflet';

const MapClickHandler = ({ onMapClick, onZoom, onMove }) => {
  useMapEvents({
    click: (e) => {
      if (onMapClick) {
        onMapClick(e.latlng);
      }
    },
    zoomend: () => {
      if (onZoom) {
        onZoom();
      }
    },
    moveend: () => {
      if (onMove) {
        onMove();
      }
    }
  });

  return null;
};

export default MapClickHandler;